import React from "react";

const Loader = () => {
    return (
        <div className="custom-loaderbg">
      <div class="custom-loader"></div>
      </div>
    );
};

export default Loader;
